import axios from 'axios'
import qs from 'qs';
import { getToken } from '@/utils/cookie'
import store from '@/store'
import { systemUpdateing } from '../api/cust';

import { Dialog, Toast } from "vant"
import { whiteList } from '../router';

const catchQueue = {};
let cancelRequest = false

function showSysUpdateInfo(msg) {
    Dialog.alert({
        title: "温馨提示",
        message: msg || '尊敬的会员：<br />平台系统正在更新中，请您稍后再试。',
        confirmButtonText: "关闭",
        cancelButtonText: "",
        messageAlign: "center",
        showCancelButton: false,
        theme: "round-button"
    })
        .then(() => { })
        .catch(() => { })
}

function loadSysUpdateInfo() {
    systemUpdateing().then((data) => {
        const { code, msg } = data
        if (code == 503) {
            dismissLoading()
            showSysUpdateInfo(msg)
            cancelRequest = true
        } else {
            cancelRequest = false
        }
    }).catch((e) => {
        const { code, msg } = e.data
        if (code == 503) {
            dismissLoading()
            showSysUpdateInfo(msg)
            cancelRequest = true
        } else {
            cancelRequest = false
        }
    })
}

function dismissLoading() {
    Toast.clear(true);
}

function currentHrefIsWhiteList() {
    let path = decodeURIComponent(location.href).split("#")[1]
    if (path.includes("redirect")) {
        let redirect = path.split("redirect=")[1]
        if (redirect.includes("?")) {
            path = redirect.split("?")[0]
        } else {
            path = redirect
        }
    } else {
        if (path.includes("?")) {
            path = path.split("?")[0]
        }
    }
    return whiteList.includes(path)
}

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    withCredentials: true, // 跨域请求中,允许传送cookie信息
    timeout: process.env.NODE_ENV == 'prod' ? 30000 : 40000, // 请求时长限制
});

/**
 * request拦截器
 * @author qingguipeng
 * @since 2019年8月26日18:26:29
 */
service.interceptors.request.use(config => {
    config.headers = { 'X-Tianjs-Version': process.env.VUE_APP_VERSION }
    config.headers['X-Tianjs-DeviceName'] = window.navigator.userAgent
    config.headers['X-Tianjs-SystemVersion'] = window.navigator.userAgent
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    if (store.getters.token) {
        config.headers.Authorization = getToken();
    }
    // console.log('cancelRequest == %O, config == %O', cancelRequest, config);
    if (config.url != "/503") {
        loadSysUpdateInfo()
    }
    if (cancelRequest && config.url != "/503") {
        delete catchQueue[url];
    }
    return config;
}, error => {
    console.log('error == %O', error);
    Promise.reject(error);
});

/**
 * response拦截器
 * @author qingguipeng
 * @since 2019年8月26日18:33:53
 */
service.interceptors.response.use(
    response => {
        const { config: { url } } = response;
        // 删除请求的URL地址
        delete catchQueue[url];
        const res = response.data;
        // console.log('response == %O', response);
        if (res) {
            /*if (res.code === 1000 || res.code === 1001) {
                store.logout('logout');
                location.href="/#/login";
                return Promise.reject(res);
            }*/
            if (res.code !== 0) {
                // if (res.code === 1000 && store.getters.token) {
                if (res.code === 1000) {
                    store.commit('logout')
                    if (!currentHrefIsWhiteList()) {
                        location.href = "/#/login";
                        // store.logout('logout');
                        console.log('登录已失效，请重新登录');
                        return
                    }
                }
                return Promise.reject(res);
            }
            return res.data;
        }
        return Promise.reject('error');
    },
    async error => {
        console.log('error == %O', error);
        if (!error.response) {
            return Promise.reject({ msg: "系统更新中" })
        }
        const { status, config: { url } } = error.response;
        if (!error.response) {
            return Promise.reject({ msg: "系统维护中..." })
        }
        switch (status) { // 其他情况补充处理
            case 404:
                delete catchQueue[url];
                break;
            default:
                delete catchQueue[url];
        }
        return Promise.reject({ msg: "系统维护中..." })
    }
);

/**
 * 在service外重新包装一层，缓存用户传参，用于401以后的补发请求
 * @param {*} params 用户传入的参数
 */
/*
const request = params => {
    // 赋值请求的URL地址
    catchQueue[params.url] = params
    return service(params)
}
*/

const request = {
    post: (url, data, config) => {
        // 赋值请求的URL地址
        catchQueue[url] = { url: url, data: data, config: config };
        var channelCode = store.getters.channel;
        data = { token: store.getters.token, chanlCode: channelCode ? channelCode.toUpperCase() : null, ...data, };
        data = qs.stringify(data);
        return service.post(url, data, config);
    },

    get: (url, data, config) => {
        // 赋值请求的URL地址
        catchQueue[url] = { url: url, data: data, config: config };
        var channelCode = store.getters.channel;
        data = { token: store.getters.token, chanlCode: channelCode ? channelCode.toUpperCase() : null, ...data, };
        data = qs.stringify(data);
        return service.get(url, data, config);
    },


    upload: function (url, data, config) {
        let defaultConfig = {
            timeout: 1000 * 60 * 3
        };
        config = Object.assign({}, defaultConfig, config);

        let formData = new FormData();
        for (let k in data) {
            formData.append(k, data[k]);
        }
        formData.append("token", store.getters.token);

        return instance.post(url, formData, config)
    },
};

export default request
